export default __webpack_public_path__ + "static/media/paypal.211bbf1c.svg";